<template>
  <div class="nav">
    <ul>
      <li @click="pageRefresh('/dashboard')" class="dashboard" id="dashboard" :class="{'active': $route.path == '/dashboard' || $route.path == '/labour'}">
        <i class="ico"></i>
        <div class="txt">Dashboard<i class="el-icon-arrow-right"></i></div>
      </li>
      <li @click="pageRefresh('/venue')" v-if="isPro" class="insight" id="insight" :class="{'active': $route.path == '/venue'}">
        <i class="ico"></i>
        <div class="txt">Insights<i class="el-icon-arrow-right"></i></div>
      </li>
      <li @click="pageRefresh('/revenue')" class="revenue-history" id="revenue-history" :class="{'active': $route.path == '/revenue'}">
        <i class="ico"></i>
        <div class="txt">Revenue History<i class="el-icon-arrow-right"></i></div>
      </li>
      <li @click="rosterLabourPage()" class="roster-labour" id="roster-labour" :class="{'active': $route.path == '/rosterAndlabourroster'||$route.path == '/rosterAndlabourlabour'||$route.path == '/rosterAndlabourarea'}">
        <i class="ico"></i>
        <div class="txt">Roster & Labour<i class="el-icon-arrow-right"></i></div>
      </li>
      <li @click="pageRefresh('/fees')" class="fees" id="fees" :class="{'active': $route.path == '/fees'}">
        <i class="ico"></i>
        <div class="txt">Platform Fees<i class="el-icon-arrow-right"></i></div>
      </li>
      <li @click="pageRefresh('/setting')" class="settings" id="settings" :class="{'active': $route.path == '/setting'||$route.path == '/setRent'||$route.path == '/stream'||$route.path == '/setInformation'||$route.path == '/target'}">
        <i class="ico"></i>
        <div class="txt">Setting<i class="el-icon-arrow-right"></i></div>
      </li>

      <li @click="pageRefresh('/rosterAndapp')" class="app-account" id="app-account" :class="{'active': $route.path == '/rosterAndapp'}">
        <i class="ico"></i>
        <div class="txt">App Account<i class="el-icon-arrow-right"></i></div>
      </li>

      <li v-if="isEosActivated && env.NAME === 'sandbox'" @click="pageRefresh('/eos')" class="eos" :class="{'active': $route.path == '/eos'}">
        <i class="ico"></i>
        <div class="txt">EOS<i class="el-icon-arrow-right"></i></div>
      </li>

      <!-- url: '/static/training/index.html' -->
      <li v-if="isDoneLoad && isENableTraining" @click="open(trainingLink)"  class="help" id="help" :class="{'active': $route.path == '/help'}">
        <i class="ico"></i>
        <div class="txt">Training Videos<i class="el-icon-arrow-right"></i></div>
      </li>

      <li @click="logout" class="logout" id="logout">
        <i class="ico"></i>
        <div class="txt">Logout<i class="el-icon-arrow-right"></i></div>
      </li>
    </ul>
  </div>
</template>

<script>
import api from '../../api/login'
import { env } from '../../env'
export default {
  inject: ['reload'],
  name: 'navcon',
  data () {
    return {
      isPro: false,
      isDoneLoad: false,
      isENableTraining: process.env.IS_ENABLE_TRAINING == '1' ? true : false,
      trainingLink: process.env.TRAINING_URL,
      isEosActivated: sessionStorage.getItem('isEosActivated') === 'true' ? true : false,
      env: env,
    }
  },
  methods: {
    open (e) {
      window.open(e, '_blank')
    },
    pageRefresh (path) {
      if (path == this.$route.path) {
        this.reload()
      }
      else {
        this.$router.push(path)
      }
    },
    logout(){
      api.logout({callback:this.callback})
    },
      callback (res) {
          sessionStorage.clear()
          window.location.reload()
          this.$router.replace('/login')
          if(res.data.code == 0){
            //
          } else if (res.data.code == 8902) {
            //
          } else{
            Utils.alert('', res.data.message, 'error')
          }
    },

    rosterLabourPage() {
      // if (this.isPro) {
      //   this.pageRefresh('/rosterAndlabourroster')
      // } else {
      //   this.pageRefresh('rosterAndlabourlabour')
      // }
        // Temporary
      this.pageRefresh('/rosterAndlabourlabour')
    }

  },

  mounted() {
    this.$root.$on('isPro', (isPro) => {
        this.isPro = isPro
        this.isDoneLoad = true
    })
  }
}
</script>

<style lang="scss" scoped>
.nav{
  color: var(--text-color);
  width: 160px;
  position: fixed;
  left: 0;
  top: 120px;
  z-index: 90;
  background: var(--background-color);
  height: 100vh;
  ul{
    width: 130px;
    box-sizing: border-box;
    padding-left: 30px;
    padding-top: 62px;
    li{
      width: 100%;
      height: 70px;
      position: relative;
      cursor: pointer;
      .ico{
        display: block;
        width: 100%;
        height: 70px;
        background-repeat: no-repeat;
        background-size: 30px 30px;
        background-position:center center;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 102;
      }
      .txt{
        width: 100px;
        height: 70px;
        box-sizing: border-box;
        padding-left: 95px;
        position: absolute;
        left: 0;
        top: 0;
        background: var(--background-color-4);
        font-size: 16px;
        line-height: 70px;
        opacity: 0;
        transition: all .5s;
        white-space: nowrap;
        overflow: hidden;
        z-index: 101;
        i{
          position: absolute;
          right: 6px;
          top: 28px;
        }
      }
    }
    li:hover{
      .txt{
        width: 240px;
        opacity: 1;
      }
    }
    li.dashboard .ico{
      background-image: url('../../assets/1.png');
    }
    li.insight .ico{
      background-image: url('../../assets/2.png');
    }
    li.revenue-history .ico{
      background-image: url('../../assets/3.png');
    }
    li.roster-labour .ico{
      background-image: url('../../assets/4.png');
    }
    li.fees .ico{
      background-image: url('../../assets/5.png');
    }
    li.settings .ico{
      background-image: url('../../assets/6.png');
    }

    li.app-account .ico{
      background-image: url('../../assets/account-1.png');
      background-size: 31px 31px !important;
    }

    li.eos .ico{
      background-image: url('../../assets/eos.svg');
      background-size: 37px 37px !important;
    }

    li.help .ico{
      background-image: url('../../assets/help.png');
    }

    li.logout .ico{
      background-image: url('../../assets/7.png');
    }
    .active{
      background: var(--background-color-4);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/navcon.vue